module.exports = __webpack_public_path__ + "img/3.86f4a29e.jpg";